export default __webpack_public_path__ + "static/media/node.34423cae.png";